import React from 'react'
import {
  ButtonContainer,
  ModalBox,
  ModalOverlay,
  PopTitle,
  PopUpContent,
  PrimaryButton,
  SecondaryButton,
} from './Dashboard/style'

export default function NewRuleModal({ handleClick, handleBack }) {
  return (
    <ModalOverlay>
      <ModalBox>
        <PopTitle>How to set up a new rule?</PopTitle>
        <PopUpContent>
          1. Choose one or more degrees & departments.
        </PopUpContent>
        <PopUpContent>
          2. Review each rule before establishing regulations for these selected
          degrees & departments.
        </PopUpContent>
        <PopUpContent>
          3. Access and edit all your established rules conveniently from the
          rule engine tab for each degree & department.
        </PopUpContent>
        <ButtonContainer>
          <ButtonContainer>
            <SecondaryButton text="Back" onClick={handleBack} />
            <PrimaryButton text="Set New Rules" onClick={handleClick} />
          </ButtonContainer>
        </ButtonContainer>
      </ModalBox>
    </ModalOverlay>
  )
}
